<template>
  <div class="pl">
    <div class="pl__container">
      <!-- Список категорий -->
      <div class="pl__left">
        <ul>
          <li
            v-for="category in list"
            :key="category.id"
            :class="{ active: category.id === selectedCategoryId }"
            @click="selectCategory(category.id)"
          >
            <!-- Иконка только для категории -->
            <i v-if="category.icon" :class="category.icon" class="category-icon"></i>{{ category.name }}
          </li>
        </ul>
      </div>

      <!-- Действия -->
      <div class="pl__right">
        <ul v-if="selectedCategory" class="pl-categories__ul">
          <li
            v-for="action in selectedCategory.actions"
            :key="action.id"
            class="pl-categories__li"
          >
            <div
              class="action-header"
              @click.stop="onActionClick(action)"
              role="button"
              :aria-expanded="hasChildren(action) ? String(isOpen(action.id)) : undefined"
            >
              <div
                v-if="hasChildren(action)"
                class="icon-wrapper"
                @click.stop="toggle(action.id)"
                role="button"
                :aria-label="isOpen(action.id) ? 'Свернуть' : 'Развернуть'"
              >
                <div class="icon" :class="{ open: isOpen(action.id) }" aria-hidden="true">
                  <div class="icon-line horizontal"></div>
                  <div class="icon-line vertical"></div>
                </div>
              </div>

              <div class="action-main">
                <div class="action-title">{{ action.name }}</div>
                <div v-if="action.description" class="action-sub">{{ action.description }}</div>
              </div>
            </div>

            <!-- Дочерние элементы -->
            <transition @enter="enter" @leave="leave">
              <div v-show="isOpen(action.id)" class="children-wrap">
                <ul class="children-list">
                  <li
                    v-for="child in action.children"
                    :key="child.id"
                    class="child-item"
                  >
                    <div
                      class="child-header"
                      @click.stop="child.disabled? showDisabledAlert() : toggleChild(child.id)"
                      :class="{ 'child-disabled': child.disabled }"
                    >
                      <div class="icon-wrapper">
                        <div class="icon" :class="{ open: isChildOpen(child.id) }">
                          <div class="icon-line horizontal"></div>
                          <div class="icon-line vertical"></div>
                        </div>
                      </div>
                      {{ child.name }}

                      <div class="child-header-button__container">
                        <button
                          class="child-header__button preview__button"
                          @click.stop="openPreviewModal()"
                          v-if="child.functionName === 'openModal'"
                        >
                         Предпросмотр
                        </button>
                        <button
                          class="child-header__button"
                          @click.stop="!child.disabled && onChildSelect(child)"
                          :class="{ 'child-active__button': isSelected(child), 'child-disabled': child.disabled }"
                        >
                          {{ isSelected(child) ? 'Выбрано' : 'Выбрать' }}
                        </button>
                        <PreviewModal
                          v-model="showPreviewModal" 
                          :modalList="modalList"
                        />
                      </div>
                    </div>

                    <transition @enter="enter" @leave="leave">
                      <div v-show="isChildOpen(child.id)" class="child-body">
                        <div class="child-body__container">
                          <input
                            v-if="child.functionName !== 'openModal'"
                            :id="'child-input-' + child.id"
                            type="text"
                            v-model="childInputs[child.id]"
                            :placeholder="child.placeholder || 'Введите текст...'"
                            :class="{ 'input-error': inputErrors[child.id] }"
                            class="child__input"
                          />
                          <div v-if="child.functionName === 'goToRef'" class="choose-el__container">
                            <p class="child-and__p">или</p>
                            <button @click.stop="selectAnchor(child)">
                              Выбрать элемент
                            </button>
                          </div>
                          <div 
                            v-if="child.functionName === 'openModal'"
                            class="nested-inputs__container"
                          >
                            <p class="nested-inputs__p">Укажите информацию которую хотите собирать</p>
                            <NestedInputs
                              v-model="modalList"
                            />
                          </div>
                        </div>
                      </div>
                    </transition>
                  </li>
                </ul>
              </div>
            </transition>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { safeClone } from '@/utils/clone.js';
import NestedInputs from '@/components/Nested/NestedInputs.vue'
import PreviewModal from '@/components/blocks/Heroes/modal.vue'

export default {
  components: { NestedInputs, PreviewModal },
  name: 'PaginationList',
  props: {
    list: { type: Array, default: () => [] },
    selectedAction: { 
      type: Object, 
      default: () => ({ data: [] })
    }
  },
  emits: ['select-action', 'select-anchor', 'on-choose-element'],
  data() {
    const base = Date.now();
    return {
      selectedCategoryId: this.list[0]?.id || null,
      selectedActionId: null,
      opened: {},
      openedChild: {},
      childInputs: {},
      inputErrors: {},
      modalList: [
        { type: "input", id: base + 1, value: "Создание заявки", placeholder: "Заголовок", label: "Заголовок" },
        { type: "input", id: base + 2, value: "Отмена", placeholder: "Отмена", label: "Кнопка" },
        { type: "input", id: base + 3, value: "Отправить", placeholder: "Сохранить", label: "Кнопка" },
        { type: "input", id: base + 4, value: "", placeholder: "Например - Укажите ваше ФИО", label: 'Текстовый ввод' }
      ],
      showPreviewModal: false,
    };
  },
  mounted () {
    this.openSelectedChildren();



    let choosedElement = this.$store.getters['choosedElement/choosedElement']
    if(choosedElement) {
      this.updateGoToRef(choosedElement)
    }
  },
  computed: {
    selectedCategory() {
      return this.list.find(cat => cat.id === this.selectedCategoryId);
    }
  },
  watch: {
    modalList: {
      handler() {

      },
      immediate: true
    },
    selectedAction: {
      handler() {
        this.openSelectedChildren();
      },
      immediate: true
    }
  },
  methods: {
    openPreviewModal () {
      this.showPreviewModal = !this.showPreviewModal
    },
    showDisabledAlert () {
      this.$store.dispatch("alert/showAlert", {
        title: "Внимание",
        message: "Нет допустимых страниц!",
        type: "warning",
        typeClass: "alert-warning",
        background: "#fff3cd",
        color: "#856404",
        autoClose: { enabled: true, delay: 4000 }
      });
    },
    _normalizeSelectedAction() {
      if (!this.selectedAction) return null;
      return (this.selectedAction && this.selectedAction.action) ? this.selectedAction.action : this.selectedAction;
    },
    openSelectedChildren() {
      const sel = this._normalizeSelectedAction();
      if (!sel) return;

      const newOpened = { ...this.opened };
      const newOpenedChild = { ...this.openedChild };
      const newChildInputs = { ...this.childInputs };

      // 1) Если в sel.data есть записи, сначала обработаем их: найдем parent по child.id (по всему list)
      if (Array.isArray(sel.data) && sel.data.length > 0) {
        sel.data.forEach(d => {
          // ищем child по id по всему списку
          for (const cat of (this.list || [])) {
            for (const a of (cat.actions || [])) {
              const child = (a.children || []).find(c => c.id === d.id);
              if (child) {
                // откроем parent и child
                newOpened[a.id] = true;
                newOpenedChild[child.id] = true;
                // заполним input если есть value
                if (d.type === 'input') newChildInputs[child.id] = d.value ?? '';
                // установим selectedCategory если нужно
                if (cat.id && cat.id !== this.selectedCategoryId) {
                  this.selectedCategoryId = cat.id;
                }
                // сохранение найденного parent для дальнейших проверок
                // (но продолжаем, т.к. может быть несколько полей)
              }
            }
          }
        });
      }

      // 2) Найдём parent action непосредственно по sel.id (если он задан)
      let parentAction = null;
      let parentCategoryId = null;
      if (sel.id != null) {
        for (const cat of (this.list || [])) {
          const found = (cat.actions || []).find(a => a.id === sel.id);
          if (found) {
            parentAction = found;
            parentCategoryId = cat.id;
            break;
          }
        }
      }

      // 3) Если parent найден — откроем его и, если ещё не открыты children, попробуем открыть child по functionName
      if (parentAction) {
        newOpened[parentAction.id] = true;
        this.selectedActionId = parentAction.id;
        if (parentCategoryId && parentCategoryId !== this.selectedCategoryId) {
          this.selectedCategoryId = parentCategoryId;
        }

        // Если ранее по sel.data не открыли child-ы (например data пустая),
        // и у parent есть child с functionName === sel.functionName — откроем его
        const anyChildAlreadyOpened = Object.keys(newOpenedChild).length > 0;
        if (!anyChildAlreadyOpened && sel.functionName) {
          const childByFn = (parentAction.children || []).find(c => c.functionName === sel.functionName);
          if (childByFn) {
            newOpenedChild[childByFn.id] = true;
            // если sel.data содержит набор полей для модалки — подгрузим modalList
            if (sel.functionName === 'openModal' && Array.isArray(sel.data)) {
              this.modalList = sel.data;
            }
          }
        }

        // Дополнительно: если sel.data есть и содержит input-поля, обработаем их для parentAction.children
        if (Array.isArray(sel.data)) {
          sel.data.forEach(d => {
            const ch = (parentAction.children || []).find(c => c.id === d.id);
            if (ch) {
              newOpenedChild[ch.id] = true;
              if (d.type === 'input') newChildInputs[ch.id] = d.value ?? '';
            }
          });
        }
      } else {
        // 4) Если parent не найден, но в sel.data есть child-id-ы — они уже обработаны выше (по всему list).
        // Ничего дополнительно не делаем.
      }

      // 5) Если sel.functionName === 'openModal' и sel.data переданы — гарантируем, что modalList подгружен
      if (sel.functionName === 'openModal' && Array.isArray(sel.data) && sel.data.length) {
        this.modalList = sel.data;
      }

      // Применяем состояния
      this.opened = newOpened;

      setTimeout(() => {
        this.openedChild = newOpenedChild;
        this.childInputs = newChildInputs;
      }, 300);
    },

    isSelected(child) {
      const sel = this._normalizeSelectedAction();
      if (!sel) return false;

      // 1) Если selectedAction.data содержит запись с id == child.id
      if (Array.isArray(sel.data) && sel.data.some(d => d.id === child.id)) {
        return true;
      }

      // 2) Если selectedAction описывает сам parent (sel.id == parent.id),
      //    и child.functionName совпадает с sel.functionName => считаем выбранным
      if (sel.id != null && sel.functionName) {
        // найдём parent по sel.id
        const parent = this.list.flatMap(c => c.actions || []).find(a => a.id === sel.id);
        if (parent) {
          // если у parent есть child с такой функцией — считаем child выбранным
          if (child.functionName && child.functionName === sel.functionName) return true;
        }
      }

      return false;
    },


    onChildSelect(child) {
      const value = this.childInputs[child.id] || '';


      if (!value && child.functionName != "openModal") {
        this.inputErrors = { ...this.inputErrors, [child.id]: true };
        this.openedChild = { ...this.openedChild, [child.id]: true };
        setTimeout(() => {
          this.inputErrors = { ...this.inputErrors, [child.id]: false };
        }, 1500);
        return;
      }
      else if(child.functionName == "openModal") {
        this.inputErrors = { ...this.inputErrors, [child.id]: false };
        this.openedChild = { ...this.openedChild, [child.id]: true };
      }

      let action = this.selectedCategory?.actions?.find(a => a.id === this.selectedActionId);
      if (!action) {
        action = this.selectedCategory?.actions?.find(a => (a.children || []).some(c => c.id === child.id));
      }

      const actionClone = safeClone(action);

      if (!Array.isArray(actionClone.data)) actionClone.data = [];

      const newDataEntry = { type: 'input', id: child.id, value };
      actionClone.data = [
        ...actionClone.data.filter(d => d.id !== child.id),
        newDataEntry
      ];

      if (child?.functionName) actionClone.functionName = child.functionName;

      

      if(child.functionName == "openModal") {
        actionClone.data = this.modalList
      }

      this.$emit('select-action', safeClone(actionClone));
    },

    selectCategory(id) {
      this.selectedCategoryId = id;
      this.selectedActionId = null;
      this.opened = {};
      this.openedChild = {};
    },

    hasChildren(action) {
      return Array.isArray(action.children) && action.children.length > 0;
    },
    isOpen(id) {
      return !!this.opened[id];
    },
    toggle(id) {
      this.opened = { ...this.opened, [id]: !this.opened[id] };
    },
    onActionClick(action) {
      if (!action) return;
      if (this.hasChildren(action)) {
        this.toggle(action.id);
        this.selectedActionId = this.selectedActionId === action.id ? null : action.id;
      } else {
        const actionClone = safeClone(action);
        if (!actionClone.functionName) {
          const firstChild = (action.children || [])[0];
          if (firstChild?.functionName) actionClone.functionName = firstChild.functionName;
        }
        this.$emit('select-action', actionClone);
        this.selectedActionId = action.id;
      }
    },

    selectAnchor(child) {
      this.$emit('on-choose-element', child);
    },

    toggleChild(id) {
      this.openedChild = { ...this.openedChild, [id]: !this.openedChild[id] };

      if (!(id in this.childInputs)) {
        let value = '';

        const found = this.selectedAction?.data?.find(d => d.id === id && d.type === 'input');
        if (found) value = found.value;

        const child = this.selectedCategory?.actions
          .flatMap(a => a.children || [])
          .find(c => c.id === id);

        this.childInputs = { ...this.childInputs, [id]: value };
      }
    },
    isChildOpen(id) {
      return !!this.openedChild[id];
    },

    updateGoToRef(newVal) {
      if (!this.selectedCategory) return;

      this.selectedCategory.actions.forEach(action => {
        const actionClone = safeClone(action);
        if (!Array.isArray(actionClone.data)) actionClone.data = [];

        let hasUpdate = false;

        // случай: сам action настроен как goToRef (без child или с data)
        if (actionClone.functionName === 'goToRef') {
          // обновляем все input-поля у action (если нужно — можно сузить логику)
          actionClone.data = (actionClone.data || []).map(d => {
            if (d.type === 'input') {
              hasUpdate = true;
              // сохраняем id, но перезаписываем value на newVal (строка)
              this.childInputs[d.id] = newVal;
              return { ...d, value: newVal };
            }
            return d;
          });
        }

        // случай: child с functionName === 'goToRef'
        (actionClone.children || []).forEach(child => {
          if (child.functionName === 'goToRef') {
            const idx = actionClone.data.findIndex(d => d.id === child.id);
            const newEntry = { type: 'input', id: child.id, value: newVal };
            if (idx >= 0) {
              actionClone.data[idx] = newEntry;
            } else {
              actionClone.data.push(newEntry);
            }
            this.childInputs[child.id] = newVal;
            // если actionClone.functionName отсутствует — назначаем от child, чтобы дальше было видно
            if (!actionClone.functionName) actionClone.functionName = child.functionName;
            hasUpdate = true;
          }
        });

        if (hasUpdate) {
          this.$emit('select-action', safeClone(actionClone));
        }
      });
    },

    enter(el) {
      el.style.display = 'block';
      const h = el.scrollHeight;
      el.style.height = '0px';
      el.style.opacity = '0';
      void el.offsetHeight;
      el.style.transition = 'height 260ms ease, opacity 200ms ease';
      el.style.height = h + 'px';
      el.style.opacity = '1';
      function done() {
        el.style.height = 'auto';
        el.style.transition = '';
        el.removeEventListener('transitionend', done);
      }
      el.addEventListener('transitionend', done);
    },
    leave(el) {
      const h = el.scrollHeight;
      el.style.height = h + 'px';
      el.style.opacity = '1';
      void el.offsetHeight;
      el.style.transition = 'height 260ms ease, opacity 200ms ease';
      el.style.height = '0px';
      el.style.opacity = '0';
      function done() {
        el.style.display = 'none';
        el.style.transition = '';
        el.removeEventListener('transitionend', done);
      }
      el.addEventListener('transitionend', done);
    }
  }
};
</script>



<style scoped>
.category-icon {
  margin-right: 0.5rem;
  font-size: 1rem;
}

.pl__container {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
}
.pl__left {
  max-width: 30%;
  width: 100%;
  border-right: 0.2rem solid var(--grey-0);
  padding-right: 1rem;
  height: 100%;
  min-height: 40rem;
}
.pl__left ul {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  flex-wrap: nowrap;
}
.pl__left li {
  padding: 0.5rem;
  cursor: pointer;
  transition: 0.3s ease all;
  border-radius: 0.5rem;
  font-weight: bold;
}
.pl__left li.active {
  background-color: var(--grey-0);
}
.pl__right {
  width: 70%;
  padding-left: 1rem;
  height: 40rem;
  overflow: hidden;
}

.pl__right ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

/* Action list */
.action-header {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.5rem;
  border-radius: 0.4rem;
  cursor: pointer;
  user-select: none;
  transition: background-color 0.18s ease, transform 0.12s ease;
}
.action-header:hover {
  background-color: rgba(0,0,0,0.03);
}
.action-header.active {
  background-color: var(--grey-0);
}

.icon-wrapper {
  width: 1.5rem;
  height: 1.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* улучшённая анимация и поворот плюса */
.icon {
  position: relative;
  width: 1rem;
  height: 1rem;
  transition: transform 260ms cubic-bezier(.2,.9,.2,1), color 180ms;
  transform-origin: center center;
  will-change: transform;
  color: currentColor;
}

/* линии плюса */
.icon-line {
  position: absolute;
  background-color: currentColor;
  border-radius: 0.125rem;
  transition: transform 260ms cubic-bezier(.2,.9,.2,1), opacity 180ms;
}

/* горизонтальная — всегда видна */
.horizontal {
  top: 50%;
  left: 0;
  width: 100%;
  height: 0.12rem;
  transform: translateY(-50%);
}

/* вертикальная — схлопывается при открытии */
.vertical {
  top: 0;
  left: 50%;
  width: 0.12rem;
  height: 100%;
  transform: translateX(-50%);
  transform-origin: center center;
  will-change: transform, opacity;
}

/* при открытом состоянии — вращаем весь значок и прячем вертикальную линию */
.icon.open {
  transform: rotate(180deg);
}

.icon.open .vertical {
  height: 0;
  transform: translateX(-50%) scaleY(0.05);
  opacity: 0;
}

/* children wrap */
.children-wrap {
  overflow: hidden;
  background: transparent;
  padding-left: 2rem;
}
.children-list {
  list-style: none;
  margin: 0;
  padding: 0.25rem 0;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
.child-item {
  border-radius: 0.5rem;
  overflow: hidden;
  border-radius: 0.35rem;
  transition: background-color 0.15s ease;
}
.child-item:hover {
  background-color: rgba(0,0,0,0.03);
}
.child-item.active {
  background-color: rgba(0,0,0,0.06);
}
.action-title {
  font-weight: 600;
}
.action-sub {
  font-size: 0.85rem;
  opacity: 0.6;
  margin-top: 0.15rem;
}
.child-header {
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
  background-color: var(--grey-0);
  padding: 0.5rem;
  cursor: pointer;
  align-items: center;
}
.child-body {
  background-color: #3b3b3b;
  padding: 1rem;
}
.child-body__container {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
.child-and__p {
  text-align: left;
  margin-bottom: 0.5rem;
  line-height: 1;
}
.child-header-button__container {
  margin-left: auto;
  display: flex;
  gap: 0.5rem;
  flex-direction: row;
  flex-wrap: nowrap;
  height: fit-content;
}
.child-header__button {
  line-height: 0rem;
  padding: 0.8em 0.8em;
  height: fit-contetn;
}
.child__input {
  border: 0.2rem solid transparent;
}
.input-error {
  border: 0.2rem solid var(--red-2);
  transition: border 0.3s ease, box-shadow 0.3s ease;
}
.input-error.show {
}
.pl-categories__ul {
  overflow: scroll;
  height: 100%;
}
.child-active__button {
  background-color: var(--blue-1);
  color: var(--color-0);
}
.nested-inputs__p {
  text-align: left;
  padding-bottom: 1rem;
  opacity: 0.5;
}

.nested-inputs__container {
  .nested-inputs {
  }
}

::v-deep(.nested-inputs__container .nested-body .nested-body__multiselect .multiselect__tags) {
  background-color: var(--color-0) !important;
  width: 100% !important;
  border: 0.1rem solid var(--color-1) !important;
  display: inline-table !important;
}

::v-deep(.nested-inputs__container .multiselect) {
  display: contents  !important;
}
::v-deep(.nested-inputs__container .nested-body .nested-body__multiselect .multiselect__tags .multiselect__tags-wrap) {
  display: flex;
  gap: 0rem;
  flex-direction: row;
  flex-wrap: wrap;
}
@media (max-width: 768px) {
  .pl__container {
    display: flex;
    flex-direction: column;
  }
  .pl__right {
    width: 100%;
    padding-left: 0;
    padding-top: 0.5rem;
  }
  .pl__left {
    min-height: fit-content;
    border: none;
    max-width: 100%;
    padding-bottom: 1rem;
    border-bottom: 0.2rem solid var(--grey-0);
  }
  .pl__left ul {
    width: 100%;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
  }

  .pl__left li {
    width: auto;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    text-wrap: nowrap;
  }
  .choose-el__container {
    display: none;
  }
  .child-header__button {

  }
  .preview__button {
    display: none;
  }
}

</style>